<template>
  <v-content style="background-color: #F8F7F7;margin-bottom: 8rem">
    <!-- Tab Menu -->
    <v-layout class="justify-center">
      <v-flex mt-4 xs12>
        <SlideGroupPortfolio :onClickCollection="getCollectionById" />
      </v-flex>
    </v-layout>

    <!-- Body -->
    <v-layout class="justify-center">
      <v-flex class="xs12">
        <!-- Debut by TCDC Connect ผลงานที่จัดกลุ่มไว้ให้คุณ-->
        <v-layout class="mt-4 mx-md-2 mx-sm-2">
          <v-flex>
            <span style="font-size: 22px">
              {{
                switchLanguage === "th"
                  ? category_collection_data.category_collection_name_th
                  : category_collection_data.category_collection_name_en
              }}
            </span>
          </v-flex>
        </v-layout>
        <v-layout mx-md-2 mx-sm-2>
          <v-flex>
            <span style="color: #FD5246;font-size: 14px">
              {{
                switchLanguage === "th"
                  ? category_collection_data.about_category_collection_th
                  : category_collection_data.about_category_collection_en
              }}
            </span>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="mt-6">
            <v-layout class="justify-center mb-6" wrap>
              <!-- Set article 2 column -->
              <v-flex lg12 md12 sm12 mb-lg-0 mb-md-0 mb-sm-0>
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm6
                    md6
                    lg6
                    px-lg-2
                    px-md-2
                    px-sm-2
                    px-0
                    mb-4
                    v-if="collections[0]"
                  >
                    <v-hover
                      v-slot:default="{ hover }"
                      open-delay="50"
                      style="cursor: pointer"
                    >
                      <v-card
                        flat
                        height="auto"
                        :elevation="hover ? 10 : 0"
                        @click="getCollectionPortfolio(collections[0])"
                      >
                        <v-layout style="max-height: 450px;">
                          <v-flex>
                            <v-img
                              :aspect-ratio="20 / 10"
                              height="100%"
                              width="100%"
                              style="border-top-left-radius: 5px;border-top-right-radius: 5px;"
                              :src="
                                collections[0].cover_path
                                  ? url +
                                    imgPath +
                                    'images_collection/' +
                                    collections[0].cover_path
                                  : require('../../assets/tcdc-color.png')
                              "
                              :contain="
                                collections[0].cover_path ? false : true
                              "
                            >
                              <v-expand-transition>
                                <div
                                  v-if="hover"
                                  class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text"
                                  style="height: 100%;"
                                >
                                  <span
                                    style="font-size: 16px;font-weight: bold"
                                    class="text-uppercase"
                                    >see detail</span
                                  >
                                </div>
                              </v-expand-transition>
                            </v-img>
                          </v-flex>
                        </v-layout>
                        <v-layout style="background-color: #FFFFFF">
                          <v-flex class="pa-3">
                            <div class="one-line">
                              {{ collections[0].collection_name_th }}
                            </div>
                            <div style="color: #C4C4C4;font-size: 11px">
                              {{ $t("update-date") }} :
                              {{
                                switchLanguage === "th"
                                  ? collections[0].date_th
                                  : collections[0].date_en
                              }}
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-hover>
                  </v-flex>

                  <v-flex
                    xs12
                    sm6
                    md6
                    lg6
                    px-lg-2
                    px-md-2
                    px-sm-2
                    mb-4
                    v-if="collections[1]"
                  >
                    <v-hover
                      v-slot:default="{ hover }"
                      open-delay="50"
                      style="cursor: pointer"
                    >
                      <v-card
                        flat
                        width="auto"
                        height="auto"
                        :elevation="hover ? 10 : 0"
                        @click="getCollectionPortfolio(collections[1])"
                      >
                        <v-layout style="max-height: 450px;">
                          <v-flex>
                            <v-img
                              :aspect-ratio="20 / 10"
                              height="100%"
                              width="100%"
                              style="border-top-left-radius: 5px;border-top-right-radius: 5px;"
                              :src="
                                collections[1].cover_path
                                  ? url +
                                    imgPath +
                                    'images_collection/' +
                                    collections[1].cover_path
                                  : require('../../assets/tcdc-color.png')
                              "
                              :contain="
                                collections[1].cover_path ? false : true
                              "
                            >
                              <v-expand-transition>
                                <div
                                  v-if="hover"
                                  class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text"
                                  style="height: 100%;"
                                >
                                  <span
                                    style="font-size: 16px;font-weight: bold"
                                    class="text-uppercase"
                                    >see detail</span
                                  >
                                </div>
                              </v-expand-transition>
                            </v-img>
                          </v-flex>
                        </v-layout>
                        <v-layout style="background-color: #FFFFFF">
                          <v-flex class="pa-3">
                            <div class="one-line">
                              {{ collections[1].collection_name_th }}
                            </div>
                            <div style="color: #C4C4C4;font-size: 11px">
                              {{ $t("update-date") }} :
                              {{
                                switchLanguage === "th"
                                  ? collections[1].date_th
                                  : collections[1].date_en
                              }}
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-hover>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <!-- More Rows -->
            <v-layout wrap>
              <v-flex
                lg4
                md4
                sm6
                xs12
                v-for="(collection, i) in collections.slice(2)"
                :key="i"
              >
                <v-hover
                  v-slot:default="{ hover }"
                  open-delay="50"
                  style="cursor: pointer"
                >
                  <v-card
                    flat
                    width="auto"
                    height="auto"
                    :elevation="hover ? 10 : 0"
                    class="mx-lg-2 mx-md-2 mx-sm-2 mx-0 mb-4 mx-md-2"
                    @click="getCollectionPortfolio(collection)"
                  >
                    <v-layout style="max-height: 450px;">
                      <v-flex>
                        <v-img
                          :aspect-ratio="20 / 10"
                          height="100%"
                          width="100%"
                          style="border-top-left-radius: 5px;border-top-right-radius: 5px;"
                          :src="
                            collection.cover_path !== null
                              ? url +
                                imgPath +
                                'images_collection/' +
                                collection.cover_path
                              : require('../../assets/tcdc-color.png')
                          "
                          :contain="
                            collection.cover_path !== null ? false : true
                          "
                        >
                          <v-expand-transition>
                            <div
                              v-if="hover"
                              class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text"
                              style="height: 100%;"
                            >
                              <span
                                style="font-size: 16px;font-weight: bold"
                                class="text-uppercase"
                                >see detail</span
                              >
                            </div>
                          </v-expand-transition>
                        </v-img>
                      </v-flex>
                    </v-layout>
                    <v-layout style="background-color: #FFFFFF">
                      <v-flex class="pa-3">
                        <div
                          style="font-size: 14px"
                          class="one-line"
                          :style="{
                            'font-size': $vuetify.breakpoint.lgAndUp
                              ? '14px'
                              : '' || $vuetify.breakpoint.mdAndUp
                              ? '14px'
                              : '' || $vuetify.breakpoint.smAndUp
                              ? '14px'
                              : '' || $vuetify.breakpoint.smAndDown
                              ? '12px'
                              : '',
                          }"
                        >
                          {{ collection.collection_name_th }}
                        </div>
                        <div
                          :style="{
                            'font-size': $vuetify.breakpoint.lgAndUp
                              ? '11px'
                              : '' || $vuetify.breakpoint.mdAndUp
                              ? '11px'
                              : '' || $vuetify.breakpoint.smAndUp
                              ? '11px'
                              : '' || $vuetify.breakpoint.smAndDown
                              ? '12px'
                              : '',
                          }"
                          style="color: #C4C4C4;font-size: 14px"
                        >
                          {{ $t("update-date") }} :
                          {{
                            switchLanguage === "th"
                              ? collection.date_th
                              : collection.date_en
                          }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-hover>
              </v-flex>
            </v-layout>

            <v-layout
              class="justify-center my-6"
              v-if="paginate.next_page === 'have'"
            >
              <v-flex class="text-center">
                <v-btn
                  width="150"
                  outlined
                  color="#FD5246"
                  :loading="btnLoading"
                  @click="getCollectionMoreById(paginate.current_page)"
                >
                  <span>{{ $t("more") }}</span>
                </v-btn>
              </v-flex>
            </v-layout>

            <!-- <pre>
              {{ collections }}
            </pre> -->
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <loading
      color="#FD5246"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="false"
    ></loading>
  </v-content>
</template>

<script>
import SlideGroupPortfolio from "../../components/slide_group/SlideGroupPortfolio";
import { domain, imgPath } from "../../services/Constants";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapState } from "vuex";

export default {
  name: "Creator",
  components: {
    SlideGroupPortfolio,
    Loading,
  },
  data: () => ({
    isLoading: false,
    btnLoading: false,
    fullPage: true,
    imgPath: imgPath,
    url: domain,
    collection_more: [],
    collections1: [],
    collections2: [],
    collectionsMany: [],
  }),
  computed: {
    ...mapState({
      collection_id: (state) => {
        return state.Collection.collection_id;
      },
      collections: (state) => {
        return state.Collection.collections;
      },
      collections_lenght: (state) => {
        return state.Collection.collections_lenght;
      },
      paginate: (state) => {
        return state.Collection.paginate;
      },
      category_collection_data: (state) => {
        return state.Collection.category_collection_data;
      },
      switchLanguage: (state) => {
        return state.Common.switchLanguage;
      },
    }),
  },
  created() {
    this.getCollectionById(this.collection_id);
    this.$store.dispatch("portfolio/clearActiveMenuCate", 2);
    this.collections1 = this.collections[0];
    this.collections2 = this.collections[1];
    this.collectionsMany = this.collections.slice(2);
  },
  methods: {
    getCollectionById(val) {
      let data = {
        id: val,
        page: 1,
        custom_paginate: 0,
      };
      this.isLoading = true;
      this.$store
        .dispatch("Collection/getCollectionById", data)
        .then((res) => {
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    getCollectionMoreById() {
      let data = {
        id: this.collection_id,
        page: this.paginate.current_page,
        custom_paginate: 1,
      };
      this.btnLoading = true;
      this.$store
        .dispatch("Collection/getCollectionMore", data)
        .then((res) => {
          this.btnLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.btnLoading = false;
        });
    },
    getCollectionPortfolio(collection) {
      this.$router.push({
        path: "sub-curated",
        query: {
          id: collection.id,
          collection_id: collection.collection_id,
          collection_name: collection.collection_name_th,
        },
      });
    },
    checkCollectionName(data) {
      if (this.switchLanguage === "th") {
        return data.length > 25
          ? data.collection_name_th.slice(0, 25) + "...."
          : data.collection_name_th;
      } else {
        return data.length > 25
          ? data.collection_name_en.slice(0, 25) + "...."
          : data.collection_name_en;
      }
    },
  },
};
</script>

<style scoped></style>
